/*
    Ecomgraduates.com
*/

// Init Bootstrap tootlips
const initBootstrapTooltips = () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach((el) => new bootstrap.Tooltip(el));
};

const bundleId = uuidv4();

initBootstrapTooltips();

// Product image gallery with SplideJS
const initProductImageGallery = () => {
    const mainSplideElem = document.querySelector('.featured-product .main-splide');
    const thumbsSplideElem = document.querySelector('.featured-product .thumbs-splide');

    const mainSplide = new Splide(mainSplideElem, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
    });

    const thumbsSplide = new Splide(thumbsSplideElem, {
        type: 'loop',
        gap: 16,
        rewind: true,
        arrows: true,
        pagination: false,
        perPage: 5,
        focus: 'center',
        isNavigation: true,
        breakpoints: {
            575: {
                perPage: 3,
                padding: { left: '2rem', right: '2rem' },
            },
        },
    });

    mainSplide.sync(thumbsSplide);
    mainSplide.mount();
    thumbsSplide.mount();
};
initProductImageGallery();

// Video inside modal
const initVideoInsideModal = () => {
    const modal = document.querySelector('#video-with-modal-modal');
    const videoElem = modal.querySelector('video');

    modal?.addEventListener('show.bs.modal', (e) => {
        const videoUrl = e.relatedTarget.dataset.mp4VideoUrl;

        videoElem.setAttribute('src', videoUrl);
        videoElem.play();
    });

    modal?.addEventListener('hide.bs.modal', () => {
        videoElem.pause();
    });
};
initVideoInsideModal();

// Switch pages
const switchPage = async (newPage) => {
    const currentPageArticle = document.querySelector('article.eg-funnel-page.show');
    const newPageArticle = document.querySelector(`article[data-page="${newPage}"`);

    currentPageArticle.classList.remove('show');
    newPageArticle.style.display = 'block';

    setTimeout(() => {
        currentPageArticle.style.display = 'none';
        newPageArticle.style.display = 'block';
        newPageArticle.classList.add('show');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);

    const headerStepsItems = document.querySelectorAll('.site-header-steps li');

    headerStepsItems.forEach((item, index) => {
        if (index + 1 <= newPage) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });

    if (newPage === 3) {
        const upsellModal = document.querySelector('#cart-upsell-modal');

        const response = await fetch('/cart.json');
        const data = await response.json();

        // eslint-disable-next-line max-len
        const isUpsellProductInCart = data.items.some((elem) => elem.variant_id === Number(upsellModal.dataset.variantId));

        if (!isUpsellProductInCart) {
            const myModal = bootstrap.Modal.getOrCreateInstance(upsellModal, {});
            setTimeout(() => {
                myModal.show();
            }, 250);
        }
    }
};

document.querySelectorAll('button[data-switch-page').forEach((btn) => {
    btn.addEventListener('click', () => {
        const { newPage } = btn.dataset;
        switchPage(Number(newPage));
    });
});

// Handle Header steps
document.querySelectorAll('.site-header-steps button').forEach((btn) => {
    btn.addEventListener('click', () => {
        const { page } = btn.dataset;
        switchPage(Number(page));
    });
});

// Open all accordion button in pricing plans (desktop only)
if (window.matchMedia('(min-width: 992px)').matches) {
    document.querySelectorAll('.eg-funnel-page-a .pricing-col-body .accordion-button').forEach((btn) => {
        btn.classList.remove('collapsed');
        btn.setAttribute('aria-expanded', true);
    });
    document.querySelectorAll('.eg-funnel-page-a .pricing-col-body .collapse').forEach((collapse) => {
        collapse.classList.add('show');
    });
}

// Load Cart container (via fetch)
const loadCartContainer = async () => {
    const container = document.querySelector('#cart-page-container');
    container.style.opacity = '.25';

    const respoonse = await fetch(window.location.href);
    const data = await respoonse.text();

    const parser = new DOMParser();
    const newDocument = parser.parseFromString(data, 'text/html');

    container.replaceWith(newDocument.querySelector('#cart-page-container'));

    initBootstrapTooltips();
};

// Check if a product is already in the cart
const isAlreadyInCart = async (variantId) => {
    const response = await fetch('/cart.json');
    const data = await response.json();


    return data.items.some((item) => item.id === variantId);
};

// Add Product to Cart
window.addProductToCart = async (btn, isGift = false) => {
    const variantId = Number(btn.dataset.variantId);

    if (await isAlreadyInCart(variantId)) {
        return;
    }

  let formData = {}
    if (isGift) {
      formData = {
        items: [{
           id: variantId,
           quantity: 1,
           properties: {
               "_bundle_id": bundleId
           }
        }],
      };
    } else {
    	formData = {
        	items: [{
            	id: variantId,
            	quantity: 1,
            	"properties": {
                  "_shipping_interval_frequency": 30,
                	"_shipping_interval_unit_type": "day",
                	"_order_interval_unit": "day",
                  "_bundle_id": bundleId
            	},
        	}],
    	};
    }
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    });

    await response.json();

    loadCartContainer();
};

// Add/Remove Product to Cart (variant 2)
window.addRemoveProductToCart = async (btn) => {
    if (btn.dataset.addOrRemove === 'add') {
        btn.textContent = 'Adding...';

        await window.addProductToCart(btn);

        btn.textContent = 'Remove';
        btn.classList.remove('btn-primary');
        btn.classList.add('btn-outline-primary');
        btn.setAttribute('data-add-or-remove', 'remove');

        btn.closest('.pricing-col-block').classList.add('active');
    } else {
        btn.textContent = 'Removing...';

        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: btn.dataset.variantId,
                quantity: 0,
            }),
        });

        btn.textContent = 'Add';
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-primary');
        btn.setAttribute('data-add-or-remove', 'add');

        btn.closest('.pricing-col-block').classList.remove('active');

        loadCartContainer();
    }
};

// Handle Quantity inputs change
window.onChangeQtyInput = async (input) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value,
        }),
    });

    loadCartContainer();
};

// handle Remove items from cart buttons
window.onRemoveItemBtnClick = async (btn) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0,
        }),
    });

    loadCartContainer();
};

// https://support.rechargepayments.com/hc/en-us/articles/360006332733-Redirect-to-subscription-checkout-
// code is slighly modified
/* eslint-disable */
window.reChargeProcessCart = (discountCode) => {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
        token=get_cookie('cart');
	}
	while(token == undefined);	var myshopify_domain='tiege-skin-care.myshopify.com'
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }

    let discount = ''

    if (discountCode.length) {
        discount = `&discount=${discountCode}`
    }

	checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+discount;
    window.location.href = checkout_url
}
/* eslint-enable */
